import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  FormControl, InputLabel, Select, MenuItem,
  Paper, Chip, Fade, Stack, CircularProgress, Grid
} from '@mui/material';
import {
  CheckCircle as CheckIcon,
  Schedule as PendingIcon,
  Edit as EditIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';

export const ACOfficerGrievanceComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [actionFormData, setActionFormData] = useState({
    ac_remark: '',
    resolved_by_ac: 'true', 
  });

  // Columns including user (created_by) details
  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'akn_no', field: 'akn_no', headerName: 'Ack No.', width: 190 },
    {
      id: 'user_name',
      field: 'user_name',
      headerName: 'Submitted By',
      width: 160,
    //   renderCell: (params) => (
    //     <Stack direction="row" spacing={0.5} alignItems="center">
    //       <PersonIcon fontSize="small" color="action" />
    //       <Typography variant="body2">{params.value}</Typography>
    //     </Stack>
    //   ),
    },
    {
      id: 'user_email',
      field: 'user_email',
      headerName: 'Email',
      width: 220,
    //   renderCell: (params) => (
    //     params.value ? (
    //       <Stack direction="row" spacing={0.5} alignItems="center">
    //         <EmailIcon fontSize="small" color="action" />
    //         <Typography variant="body2">{params.value}</Typography>
    //       </Stack>
    //     ) : '—'
    //   ),
    },
    {
      id: 'user_phone',
      field: 'user_phone',
      headerName: 'Phone',
      width: 150,
    //   renderCell: (params) => (
    //     params.value ? (
    //       <Stack direction="row" spacing={0.5} alignItems="center">
    //         <PhoneIcon fontSize="small" color="action" />
    //         <Typography variant="body2">{params.value}</Typography>
    //       </Stack>
    //     ) : '—'
    //   ),
    },
    {
      id: 'complaint_type',
      field: 'complaint_type',
      headerName: 'Type',
      width: 110,
    },
    {
      id: 'complaint_regarding',
      field: 'complaint_regarding',
      headerName: 'Regarding',
      width: 280,
    },
    {
      id: 'Address',
      field: 'Address',
      headerName: 'Address',
      width: 200,
    },
    {
      id: 'status',
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: () => (
        <Chip
          icon={<PendingIcon />}
          label="Pending AC"
          color="warning"
          size="small"
          variant="outlined"
        />
      ),
    },
    {
      id: 'action',
      field: 'action',
      headerName: 'AC Action',
      width: 140,
      renderCell: (params) => (
        <IconButton
          color="primary"
          size="small"
          title="Take Action"
          onClick={() => handleActionClick(params.row)}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      ),
    },
  ];

  useEffect(() => {
    fetchACGrievances();
  }, []);

  const fetchACGrievances = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/grievance/officer-ac-grievances/`
      );

      const apiData = res.data.map((item, index) => {
        const g = item.grievance || {};
        const createdBy = g.created_by || {};

        return {
          id: item.id,
          slNo: index + 1,

          grievance_raw: item,             
          grievance_id: g.id,
          akn_no: g.akn_no,
          Address: g.Address,
          Description: g.Description,
          complaint_type: g.complaint_type,
          complaint_regarding: g.complaint_regarding,
          status: g.status,
          doc: g.doc,

          // created_by user details
          user_name: createdBy.name || '',
          user_email: createdBy.email || '',
          user_phone: createdBy.phone_number || '',

          // status flags
          is_resolved_by_ac: item.is_resolved_by_ac,
          is_resolved_by_js: item.is_resolved_by_js,
          is_resolved_by_sploca: item.is_resolved_by_sploca,
        };
      });

      setRows(apiData);
    } catch (err) {
      console.error(err);
      setSnackbarMessage('Failed to load AC grievances.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleActionClick = (row) => {
    setSelectedGrievance(row);
    setActionFormData({
      ac_remark: '',
      resolved_by_ac: 'True', 
    });
    setActionDialogOpen(true);
  };

  const handleActionFormChange = (e) => {
    const { name, value } = e.target;
    setActionFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleACActionSubmit = async () => {
    if (!selectedGrievance) return;

    setSubmitLoading(true);
    try {
      await api.patch(
        `/grievance/officer-ac-grievances/${selectedGrievance.id}/`,
        actionFormData
      );

      setSnackbarMessage('Grievance updated successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setActionDialogOpen(false);
      fetchACGrievances();
    } catch (err) {
      console.error(err);
      setSnackbarMessage('Failed to update grievance.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        minHeight="60vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ backgroundColor: '#f5f5f5' }}
      >
        <CircularProgress size={40} thickness={4} />
      </Box>
    );
  }

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          width: '100%',
          mt: 3,
          mb: 3,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          background: 'linear-gradient(145deg,#ffffff 0%,#f8fafc 100%)',
          border: '1px solid rgba(255,255,255,0.2)',
        }}
      >
        {/* Header */}
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'linear-gradient(135deg,#4caf50 0%,#2e7d32 100%)',
            color: 'white',
            p: 3,
            borderRadius: '16px 16px 0 0',
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 50,
                height: 50,
                borderRadius: '12px',
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CheckIcon sx={{ color: 'white' }} />
            </Box>
            <Box sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.4)' }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 800,
                  fontSize: '1.75rem',
                  color: 'white',
                  lineHeight: 1.2,
                }}
              >
                Grievances Management
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.95, fontWeight: 500 }}>
                View user details and take action on pending grievances
              </Typography>
            </Box>
          </Stack>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Pending: {rows.length}
          </Typography>
        </Paper>

        {/* Table */}
        <Box p={3}>
          <TableComponent
            columns={columns}
            rows={rows}
            manageColumnStatus
            enableSort="true"
            sx={{
              borderRadius: 2,
              '& .MuiDataGrid-columnHeaders': {
                background: 'linear-gradient(90deg,#4caf50 0%,#2e7d32 100%)',
                color: '#fff',
                fontWeight: 700,
                fontSize: '0.875rem',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: 'rgba(76,175,80,0.04)',
              },
            }}
          />
        </Box>

        {/* AC Action Dialog */}
        <Dialog
          open={actionDialogOpen}
          onClose={() => setActionDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              background: 'linear-gradient(135deg,#4caf50 0%,#2e7d32 100%)',
              color: 'white',
              fontWeight: 700,
              py: 2.5,
              px: 3,
            }}
          >
            Action – {selectedGrievance?.akn_no}
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            {/* User + Grievance summary */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                Grievance Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    User Name
                  </Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {selectedGrievance?.user_name}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Email
                  </Typography>
                  <Typography variant="body2">
                    {selectedGrievance?.user_email || '—'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Phone
                  </Typography>
                  <Typography variant="body2">
                    {selectedGrievance?.user_phone || '—'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Ack No
                  </Typography>
                  <Typography variant="body2">
                    {selectedGrievance?.akn_no}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Regarding
                  </Typography>
                  <Typography variant="body2">
                    {selectedGrievance?.complaint_regarding}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Address
                  </Typography>
                  <Typography variant="body2">
                    {selectedGrievance?.Address}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>

            {/* AC action form */}
            <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
                Decision
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Action</InputLabel>
                    <Select
                      name="resolved_by_ac"
                      label="Action"
                      value={actionFormData.resolved_by_ac}
                      onChange={handleActionFormChange}
                    >
                      <MenuItem value="True">Resolved</MenuItem>
                      <MenuItem value="False">Reviewed (Not Resolved)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="ac_remark"
                    label="AC Remarks *"
                    fullWidth
                    multiline
                    rows={4}
                    value={actionFormData.ac_remark}
                    onChange={handleActionFormChange}
                    placeholder="Enter remarks / resolution details..."
                    required
                  />
                </Grid>
              </Grid>
            </Paper>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 0 }}>
            <Button
              onClick={() => setActionDialogOpen(false)}
              variant="outlined"
              disabled={submitLoading}
              sx={{ textTransform: 'none', borderRadius: 2, px: 4 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleACActionSubmit}
              variant="contained"
              disabled={submitLoading || !actionFormData.ac_remark.trim()}
              sx={{
                textTransform: 'none',
                borderRadius: 2,
                px: 4,
                background: 'linear-gradient(135deg,#4caf50 0%,#2e7d32 100%)',
              }}
            >
              {submitLoading ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Saving...
                </>
              ) : (
                'Submit'
              )}
            </Button>
          </DialogActions>
        </Dialog>

        <SnackBarComponent
          open={snackbarOpen}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
      </Box>
    </Fade>
  );
};
